
import axios from 'axios';

declare global {
  interface Window {
    bt_logger: (props: LogItem) => void;
    sts_base_url: string;
    sts_current_page: string;
    sts_current_url: string;
  }
}

type LogItem = {
  severity: string;
  description: string;
  type?: string;
  event_source?: string;
  file?: string;
  line?: number|'unknown';
  userId?: string | null;
  throttle?: 'never_repeat' | 'daily' | 'hourly' | 'minutely' | 'none';
}

export default function bt_logger(props:LogItem) {
  if (props && props.severity && props.description){
    if (!props.event_source) props.event_source = `${window.sts_current_page} (${window.sts_current_url})`;
    if (!props.line) props.line = `unknown`;

    if (!props.throttle) props.throttle = `never_repeat`; // Unless defined, never create duplicate logs from logging.ts
    console.warn('Creating Log Entry with data', props);
    axios.post(window.sts_base_url + '/simple/log_api', props, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

window.bt_logger = bt_logger;
